import { IFirestoreUserRedemptionCodeRequestRepository } from "../../../cloudServices/googleFirebaseServices/database/firestore/FirestoreUserRedemptionCodeRequestRepository";
import { FirestoreDataRepositoryFactory } from "../../../cloudServices/googleFirebaseServices/database/firestore/FirestoreDataRepositoryFactory";
import { enumFirestoreDataRepositoryDataType } from "../../../cloudServices/googleFirebaseServices/database/firestore/enums";
import { IFirestoreBaseRepository } from "../../../cloudServices/googleFirebaseServices/database/firestore/FirestoreBaseRepository";
import { IUserRedemptionCodeRequest, IUserRedemptionCodeRequestAsJson } from "../../../../dataObjects/models/userRedemptionCodeRequest";


export function saveUserRedemptionCodeRequest(userRedemptionCodeRequest: IUserRedemptionCodeRequest): Promise<void> {
  return new Promise<void>(async (resolve, reject) => {
    try {
      // get a UserRedemptionCodeRequest repository from the repository factory
      const firestoreUserRedemptionCodeRequestRepository: IFirestoreUserRedemptionCodeRequestRepository =
        FirestoreDataRepositoryFactory.CreateDataRepository(enumFirestoreDataRepositoryDataType.UserRedemptionCodeRequest) as
        IFirestoreBaseRepository<IUserRedemptionCodeRequest, IUserRedemptionCodeRequestAsJson>;

      // determine if the UserRedemptionCodeRequest already exists by calling the repository get() method to try and get the object
      const existingUserRedemptionCodeRequest: IUserRedemptionCodeRequest | undefined = await firestoreUserRedemptionCodeRequestRepository.get(userRedemptionCodeRequest.id);

      // If the UserRedemptionCodeRequest wasn't found, we will create a new instance. If it exists, we'll update the existing instance.
      if (existingUserRedemptionCodeRequest === undefined) {
        // call repository method to create the UserRedemptionCodeRequest
        await firestoreUserRedemptionCodeRequestRepository.create(userRedemptionCodeRequest);
      } else {
        // call repository method to update the UserRedemptionCodeRequest
        await firestoreUserRedemptionCodeRequestRepository.update(userRedemptionCodeRequest);
      }

      resolve();
    } catch (error: any) {
      reject(error);
    }
  });
}